import { z } from 'zod/v4';

export interface IServiceArea {
  id: number;
  name: string;
}

export const SERVICE_AREA: z.ZodType<IServiceArea> = z.object({
  id: z.number(),
  name: z.string(),
});

export const SERVICE_AREAS: z.ZodType<IServiceArea[]> = z.array(SERVICE_AREA);
